import { Component, OnInit } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppDialogUiReduxObject, ConfirmationDialogButton, ConfirmationDialogComponent } from '@safarilaw-webapp/shared/dialog/store-access';
import { AbortSave } from '@safarilaw-webapp/shared/redux';

import { NgClass } from '@angular/common';
import { FormControlService } from '@safarilaw-webapp/shared/ui-kit/safari-form';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { catchError, mergeMap, of, throwError } from 'rxjs';
import { ReduxFormId } from '../../../../enums';
import { FolderInfo, UpdateSubfolderDialogFormComponent } from './update-subfolder-dialog-form/update-subfolder-dialog-form.component';

@Component({
  selector: 'sl-lpms-update-subfolder-dialog',
  templateUrl: './update-subfolder-dialog.component.html',
  styleUrls: ['./update-subfolder-dialog.component.scss'],
  imports: [UpdateSubfolderDialogFormComponent, NgClass]
})
export class UpdateSubfolderDialogComponent extends ConfirmationDialogComponent implements OnInit {
  static ClassId = 'UpdateSubfolderDialog_243c87af-71b5-4d29-9332-ba9df2fd59b2';
  ConfirmationDialogButton = ConfirmationDialogButton;

  folder: FolderInfo = undefined;

  constructor(
    dialogReduxObject: AppDialogUiReduxObject,
    bsModalService: BsModalService,
    store: Store<any>,
    actions: Actions,
    bsModalRef: BsModalRef,
    private formApi: FormControlService
  ) {
    super(dialogReduxObject, bsModalService, store, actions, bsModalRef);
  }

  handleSaveError(err) {
    if (!(err instanceof AbortSave)) {
      return throwError(() => err);
    }

    return of(null);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.folder = {
      folders: [
        {
          name: this.data?.name || ''
        }
      ],
      id: null
    };
  }
  get shouldShowAddSubfolderNameButton() {
    return this.isNewSubfolderDialog;
  }
  get isNewSubfolderDialog() {
    // A very simple way to detect if this is a brand new subfolder without having to pass anything else.
    // If we don't have anything in the name property when the dialog spins up we can assume that this was invoked
    // via click on New Subfolder. if the is already passed in that this is Rename function
    return !this.data?.name;
  }

  closeModal(dialogButton: ConfirmationDialogButton = ConfirmationDialogButton.Auto) {
    if (dialogButton == ConfirmationDialogButton.Ok) {
      of(null)
        .pipe(
          // Submit (validate form - value returned from the above doesn't matter)
          mergeMap(() => this.formApi.submitOnce$<{ folders: { name: string }[] }>([{ id: ReduxFormId.UpdateOrCreateFolder }], true)),

          // We always have to end with the call to handleSaveError. This function knows
          // not to throw on AbortSave errors, but throw on others (unexpected).
          // In case of AbortSave error it returns NULL which is always used to check in the final
          // subscribe prior to navigating away
          catchError(err => this.handleSaveError(err))
        )
        .subscribe(result => {
          // If we got to this point we either have a result of forkJoin(saveresult, fileResult) OR NULL
          // if AbortSave was thrown. We don't really care about the final result , just whether it's
          // null or not.
          if (result) {
            this.dialogData = {
              subfolderNames: result[0].appModel.folders.map(o => o.name)
            };
            super.closeModal(dialogButton);
          }
        });
    } else {
      super.closeModal(dialogButton);
    }
  }
  get isOkDisabled() {
    return this.closeDialogRequestedBy != null;
  }
  get dialogHeaderText() {
    return !this.isNewSubfolderDialog ? 'Rename Subfolder' : 'New Subfolder';
  }
}
